export default __webpack_public_path__ + "static/media/330_dummy2016-beauty02-mobile-de.1c9ff4cd.png";